import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { withStyles } from '@material-ui/core/styles';

import { Field } from 'redux-form';

import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import CheckboxField from 'components/fields/CheckboxField';
import TextField from 'components/fields/TextField';
import IconInfo from 'components/icons/IconInfo';
import Tooltip from 'components/common/Tooltip';

import * as normalize from 'utils/normalize';

import pxToEm from 'styles/pxToEm';
import pxToRem from 'styles/pxToRem';

const styles = theme => ({
  grid: {
    marginTop: 8,
  },
  label: {
    display: 'inline-block',
    position: 'relative',
    marginBottom: 7,
    fontSize: pxToRem(12),
    letterSpacing: pxToEm(0.5),
    fontWeight: 700,
    color: theme.palette.grey[600],
    transform: 'none',
    whiteSpace: 'nowrap',
  },
  tooltip: {
    verticalAlign: 'top',
    marginLeft: 4,
    marginTop: -1,
  },
  iconInfo: {
    display: 'block',
    width: 14,
    height: 14,
    color: theme.palette.primary.A400,
    cursor: 'pointer',
  },
});

const InventoryStockLineCreateEditRetailPriceFields = ({ variant, classes, ...fields }) => {
  const retailPrice = get(fields, 'Retail Price').input.value;
  return (
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={4}
      >
        <Field
          id="Retail Price"
          name="Retail Price"
          label="Retail Unit Price"
          component={TextField}
          normalize={normalize.price}
          errorPlacement="top"
          fullWidth
        />
      </Grid>
      <Grid
        item
      >
        <InputLabel
          className={classes.label}
          disableAnimation
          shrink={false}
        >
          Use Retail Price?
          <Tooltip
            className={classes.tooltip}
            content={
              <Typography>
                Leave both unchecked to use payer defaults (Medicare/Medicaid).<br /> Turn one on to override that price with the product’s Retail Price.
              </Typography>
            }
            color="grey"
            placement="top"
          >
            <IconInfo className={classes.iconInfo} />
          </Tooltip>
        </InputLabel>
        <div>
          <Grid
            container
            spacing={24}
          >
            <Grid item>
              <Field
                id="Is Retail Price For Claims"
                name="Is Retail Price For Claims"
                label="For Claims"
                component={CheckboxField}
                disabled={!retailPrice}
              />
            </Grid>
            <Grid item>
              <Field
                id="Is Retail Price For Self Pay"
                name="Is Retail Price For Self Pay"
                label="For Self Pay"
                component={CheckboxField}
                disabled={!retailPrice}
              />
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
};

InventoryStockLineCreateEditRetailPriceFields.propTypes = {
  variant: PropTypes.oneOf(['Boxes', 'Kcal Units']),
  classes: PropTypes.shape({
    label: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

InventoryStockLineCreateEditRetailPriceFields.defaultProps = {
  variant: 'Boxes',
};

export default withStyles(styles)(InventoryStockLineCreateEditRetailPriceFields);



// WEBPACK FOOTER //
// ./src/components/inventory/InventoryStockLineCreateEditDialog/InventoryStockLineCreateEditRetailPriceFields.js